<template>
  <ion-page>
    <ion-header class="header-container">
      <ion-toolbar class="header-toolbar">
        <ion-title class="page-title">My Favorites</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <div v-if="loading" style="text-align: center; margin-top: 2em">
        Loading favorites...
      </div>
      <div v-else-if="cafes && cafes.length > 0">
        <CoffeeShopCard :cafes="cafes" />
      </div>
      <div v-else style="text-align: center; margin-top: 2em; color: #828282">
        No favorites yet
      </div>
    </ion-content>
    <TheFooter name="TheFooter" />
  </ion-page>
</template>
<style scoped>
.center-img {
  display: flex;
  justify-content: center;
}
.fav-card {
  margin-bottom: 10px;
  height: 100px;
}
.h1-menu {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #1b1b1b;
  margin-top: 42px;
  margin-bottom: 25px;
  text-align: center;
}
.fav-h2 {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  color: #1b1b1b;
  margin-top: 0px;
  margin-bottom: 5px;
  text-align: left;
  display: block;
}
.favback-icon {
  height: 20px;
  width: 20px;
  margin-top: 35%;
  margin-left: 20%;
}
.favorites-div {
  padding: 5%;
}
.img-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.img-container img {
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
}
.dotsep-icon {
  vertical-align: middle;
  width: 3px;
  height: 3px;
  padding-right: 10px;
  padding-left: 10px;
}
.rating-txt {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 132.6%;
  letter-spacing: 0.02em;
  color: #1b1b1b;
}
.fav-cafeinfo {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 132.6%;
  letter-spacing: 0.02em;
  color: #828282;
  display: block;
  margin-bottom: 5px;
}
.fav-cafeinfo2 {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 132.6%;
  letter-spacing: 0.02em;
  color: #828282;
}
.banner-icon {
  vertical-align: middle;
  padding-right: 5px;
  width: 11px;
}

/* Header Container */
.header-container {
  --background: #f87e63;
}

.header-toolbar {
  --background: #f87e63;
  --border-width: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 64px;
}

.page-title {
  --color: #ffffff;
  font-family: "Gilroy", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
}
</style>
<script>
import axios from "axios";
import { defineComponent } from "vue";
import CoffeeShopCard from "@/components/CoffeeShopCard.vue";
import TheFooter from "@/components/TheFooter.vue";
import {
  IonContent,
  IonIcon,
  IonPage,
  IonRow,
  IonCol,
  IonLabel,
  IonInput,
  IonButton,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
} from "@ionic/vue";

const BASE_URI =
  process.env.VUE_APP_BASE_URI !== undefined
    ? process.env.VUE_APP_BASE_URI
    : "https://api.onecoffeeapp.com.au";

export default defineComponent({
  name: "FavoritesPage",
  components: {
    IonContent,
    IonIcon,
    IonPage,
    IonRow,
    IonCol,
    IonLabel,
    IonInput,
    IonButton,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonBackButton,
    CoffeeShopCard,
    TheFooter,
  },
  data() {
    return {
      cafes: [],
      loading: true,
    };
  },
  created() {
    this.getFavorites();
  },
  methods: {
    async getFavorites() {
      this.loading = true;
      this.cafes = [];

      // Check if user is logged in
      const token = localStorage.getItem("token");
      const isLoggedIn = token !== null && token !== "null" && token !== "";

      if (!isLoggedIn) {
        // User not logged in, don't make API call
        this.loading = false;
        return;
      }

      const axiosConfig = {
        headers: {
          Authorization: token,
        },
      };

      try {
        let result = await axios.get(
          BASE_URI + "/favorites/get-favorites-with-details",
          axiosConfig
        );
        this.cafes = result.data.data || [];
      } catch (error) {
        console.error("Error fetching favorites:", error);
        // Handle auth errors gracefully - user might not have token or be logged in
        if ([400, 401, 403].includes(error.response?.status)) {
          this.cafes = [];
        }
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>
